"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustWalletConnector = void 0;
const MetamaskConnector_1 = require("./MetamaskConnector");
const Types_1 = require("../../Types");
class TrustWalletConnector extends MetamaskConnector_1.MetamaskConnector {
    constructor(config) {
        super(config, {
            name: Types_1.WalletConnectors.TrustWallet,
            displayName: "TrustWallet",
            isWallet: true,
        });
    }
    async isAvailable() {
        return !!this.getAgent() && this.getAgent().isTrust;
    }
}
exports.TrustWalletConnector = TrustWalletConnector;
